export enum EntityStoreKey {
  offerAssignments = 'offerAssignments',
  offerFilters = 'offerFilters',
}
